class WidgetRetriever {
  get(params) {
    const url = `/browse/search/widget?${Object.keys(params)
      .map(key => `${key}=${params[key]}`)
      .join('&')}`;

    return fetch(`${url}`, { credentials: 'include' })
      .then(res =>
        res.status > 200 ? Promise.reject(res) : Promise.resolve(res)
      )
      .then(res => res.json());
  }
}

module.exports = WidgetRetriever;
